import * as React from 'react'

import { Box, SearchField, type SortDirection, Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useDebouncedSearch } from 'modules/core/hooks/useSearch'
import i18n from 'modules/core/lib/i18n'

import type QuestionGroup from 'modules/reviews/store/models/QuestionGroup'

import Body from './Body'
import Header from './Header'

interface Props {
  formId: number
  questionGroups: QuestionGroup[]
  isAnonymous: boolean
}

function ReviewsTable({ questionGroups, formId, isAnonymous }: Props) {
  const { navigation } = useNavigation()

  const { search, debouncedSearch, onSearch } = useDebouncedSearch()
  const [direction, setDirection] = React.useState<SortDirection>('asc')
  const [attribute, setAttribute] = React.useState<string>('reviewer')

  const onSort = (attribute: string, direction: SortDirection) => {
    setDirection(direction)
    setAttribute(attribute)
  }

  const computeRoute = (questionGroup: QuestionGroup): string => {
    const {
      access: { id: userId },
    } = useCurrentSession()
    if (userId === questionGroup.respondent?.id) {
      return navigation.performance.reviews.id.writeReviews.answerQuestionGroupId.fullPath({
        id: formId,
        question_group_id: questionGroup.attributes.id,
      })
    } else {
      return navigation.performance.reviews.id.reviews.targetReviewers.responseQuestionGroupId.fullPath(
        {
          id: formId,
          question_group_id: questionGroup.attributes.id,
          user_id: questionGroup.target.id,
        }
      )
    }
  }

  const TableOptions = () => (
    <Box flexGrow>
      <SearchField
        variant="big"
        search={search}
        onSearch={onSearch}
        placeholder={i18n.t('common.search')}
      />
    </Box>
  )

  return (
    <Table options={TableOptions}>
      <Header onSort={onSort} attribute={attribute} direction={direction} />
      <Body
        isAnonymous={isAnonymous}
        questionGroups={questionGroups}
        search={debouncedSearch}
        computeRoute={computeRoute}
        attribute={attribute}
        direction={direction}
      />
    </Table>
  )
}

export default observer(ReviewsTable)
